import { Lock } from "lucide-react";
import { useAuth } from "@/auth/useAuth";

/** Mostrata quando una chiamata /api/rete/* risponde 403 `responsabile_disattivato`:
 *  la persona è entrata, ma l'amministrazione le ha spento l'accesso alla rete. */
export function AccessoSospeso() {
  const { logout } = useAuth();
  return (
    <div className="max-w-md mx-auto text-center py-16 space-y-4">
      <div className="inline-flex bg-amber-100 rounded-2xl p-3">
        <Lock size={26} className="text-amber-700" aria-hidden="true" />
      </div>
      <h2 className="text-xl font-bold text-text">Accesso sospeso</h2>
      <p className="text-sm text-muted-foreground">
        Il tuo accesso alla rete è stato sospeso. Rivolgiti all'amministrazione.
      </p>
      <button
        type="button"
        onClick={() => void logout()}
        className="min-h-[44px] px-5 bg-brand text-white rounded-lg text-sm font-medium hover:bg-brand-dark transition-colors"
      >
        Esci
      </button>
    </div>
  );
}
